import { useState } from "react";
import { AddToCartButton } from "../cart/add-to-cart-button";
import { cn } from "../../lib/utils";
import { amountRange, credits, creditsFor, planAmountError, type Product } from "./types";

interface PlanAmountPickerProps {
  product: Product;
}

/**
 * A credits plan on its card: the account types how much to buy it for and sees the
 * credits that buys before adding it to the cart.
 */
export function PlanAmountPicker({ product }: PlanAmountPickerProps) {
  const [raw, setRaw] = useState("");
  const error = planAmountError(product, raw);
  const amount = error ? undefined : Number(raw);

  return (
    <div className="space-y-2">
      <label className="block">
        <span className="mb-1 block text-xs font-medium text-ink-2">Amount (₹)</span>
        <input
          value={raw}
          inputMode="numeric"
          onChange={(e) => setRaw(e.target.value.replace(/[^\d]/g, ""))}
          placeholder={String(product.min_amount ?? 1)}
          aria-label={`Amount for ${product.name}`}
          aria-invalid={Boolean(raw && error)}
          className={cn(
            "h-10 w-full rounded-lg border bg-elevated px-3 text-sm tabular-nums text-ink focus:outline-none focus:ring-2 focus:ring-brand/30",
            raw && error ? "border-danger/50" : "border-line focus:border-brand",
          )}
        />
      </label>
      <p className={cn("min-h-[1.25rem] text-xs", raw && error ? "text-danger" : "text-ink-2")} aria-live="polite">
        {amount !== undefined ? (
          <>
            = <span className="font-semibold tabular-nums text-ink">{credits(creditsFor(amount, product.price))}</span> credits (minutes)
          </>
        ) : raw ? (
          error
        ) : (
          `Choose ${amountRange(product)}`
        )}
      </p>
      <AddToCartButton
        productId={product.id}
        productName={product.name}
        amount={amount}
        disabled={amount === undefined}
        className="w-full"
      />
    </div>
  );
}
